import TokenIcon from './TokenIcon.mjs';

export default function PerkCartItem({ perk, handleSelect, handleQty }) {
  return (
    <div className="perk-cart-item d-flex align-items-center gap-2">
      <div className="rounded-pill text-dark-subtle fs-lg fw-bold d-flex gap-2 align-items-center border shadow flex-grow-1 p-1 pe-3">
        <span className="perkIcon text-primary">
          <TokenIcon name={perk.icon} width="40" height="40" />
        </span>

        <div className="item-name flex-grow-1 overflow-hidden">
          <span className="flex-grow-1">{perk.fullName}</span>
        </div>
        <span className="h3 mb-0">{perk.qty}</span>
      </div>

      <button
        role="button"
        className="border-0 px-0 py-1"
        onClick={() => {
          handleSelect(perk.id);
          handleQty(perk.id, 'clear');
        }}
      >
        <span className="material-icons fs-4 align-middle">delete</span>
      </button>
    </div>
  );
}
